import React from 'react'
import _ from 'lodash'
import {IndexLink, Link} from 'react-router'

import {Button, Icon, Menu} from 'antd'

import {Overview} from './networks'
import {SetupGuide} from './setup-guide'

import {NetworksStorage, NetworkStorage} from 'storage'

import {RequireAuth} from '../auth'

import {Network} from './network'
import {Device} from './device'
// import {SetupGuide} from './SetupGuide.jsx'

import {NotFound} from 'pages/NotFound.jsx'

const NetworkNav = ({networks, nid, route, routes, ...rest}) => {
   return (
      <div>
         {0 < _.size(networks) &&
            <Menu selectedKeys={[_.last(routes).path]}>
               {_.map(networks, net => (
                  <Menu.Item key={'network/' + net.key}>
                     <Link to={`/dashboard/network/${net.key}`}>
                        {net.name || net.key}
                     </Link>
                  </Menu.Item>
               ))}

               <Menu.Divider />

               <Menu.Item key="setup">
                  <IndexLink to="/dashboard/setup">
                     <Icon type="plus" />
                     Create new network
                  </IndexLink>
               </Menu.Item>
            </Menu>}

         {0 === _.size(networks) &&
            <p className="lead copy" style={{padding: '25px'}}>
               You haven't created your first network yet!
            </p>}

         {null === _.size(networks) &&
            <p className="lead copy" style={{padding: '25px'}}>loading...</p>}
      </div>
   )
}

NetworkNav.propTypes = {
   networks: React.PropTypes.array.isRequired,
   nid:      React.PropTypes.string.isRequired
}

NetworkNav.defaultProps = {
   networks: [],
   nid:      ''
}

const Sidebar = props => (
   <div className="sidebar">
      <h4>Networks</h4>

      <NetworksStorage>
         <NetworkNav {...props} />
      </NetworksStorage>
   </div>
)

export const Dashboard = ({children, params, ...props}) => {
   console.log('render', 'dashboard/index', window.location.hash)

   return (
      <div className="dashboard">
         <RequireAuth {...props}>
            <NetworksStorage>
               {params.nid
                  ? <NetworkStorage nid={params.nid} Sidebar={Sidebar}>
                       {React.cloneElement(children, {
                          Network: Network,
                          Sidebar: Sidebar
                       })}
                    </NetworkStorage>
                  : React.cloneElement(children, {Network: Network, Sidebar: Sidebar})}
            </NetworksStorage>
         </RequireAuth>
      </div>
   )
}

Dashboard.propTypes = {
   params:   React.PropTypes.object.isRequired,
   children: React.PropTypes.node.isRequired
}

Dashboard.childRoutes = [
   {
      component:   Overview,
      childRoutes: Overview.childRoutes
   },
   {
      path:        'network/:nid',
      component:   Network,
      childRoutes: Network.childRoutes,
      onEnter:     Network.onEnter
   },
   {
      path:        'device/:nid/:key',
      component:   Device,
      childRoutes: Device.childRoutes,
      onEnter:     Device.onEnter
   },
   {
      path:        'setup',
      component:   SetupGuide,
      childRoutes: SetupGuide.childRoutes
   },
   {component: NotFound},
   {
      path:      '*',
      component: NotFound
   }
]



// WEBPACK FOOTER //
// lib/bundle/dashboard/index.js